import client from '../../providers/fetchClient'

export const aprovePoposal = (id, data) => client.put(`/v3/proposals/${id}/approve`, data)
